import React from "react"
import TodoImg from "./TodoImg"

export default function TodoItem({todo}) {
return(
        <li>{todo.id} : 
        <TodoImg img={todo.imageUrl}/>
        : {todo.title}
        </li>
)}